import { keys } from '@rehaje/shared'

import { SchemaActionDefinition } from './SchemaDefinition'
import { ActionDefinition } from './TypedDefinition'

import type { ActionNode, ActionSpecific } from './TypedNode'
import type { PluginVisitors, RehajePlugin } from '@rehaje/core'

export interface ActionDefinitionConstructor {
  new (): ActionDefinition
}

export interface ActionNodeConstructor {
  new (specific: ActionSpecific): ActionNode
  definition?: ActionDefinitionConstructor
}
export interface ActionPluginProps extends PluginVisitors {
  actions?: Record<string, ActionNodeConstructor>
}

export class ActionPlugin implements RehajePlugin {
  props: ActionPluginProps

  visitors: PluginVisitors
  constructor(props?: ActionPluginProps) {
    this.props = { ...props }
    this.visitors = this.__r_createVisitors()
  }

  __r_createVisitors() {
    const visitors: PluginVisitors = {
      definitions: {
        Action: ActionDefinition,
        'Schema.Action': SchemaActionDefinition,
        ...this.props.definitions
      },
      nodes: {
        ...this.props.nodes
      }
    }
    if (this.props.actions) {
      for (const key of keys(this.props.actions)) {
        const type = `Action.${key}`
        const action = this.props.actions[key]
        if (action) visitors.nodes![type] = action
        if (action?.definition) visitors.definitions![type] = action.definition
      }
    }
    return visitors
  }
}
